<div
  *ngIf="ready && !visibility.isHidden && sections"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <ng-container *ngFor="let section of sections; trackBy: trackByFn">
    <div class="accordion mw568">
      <button class="accordion-header" (click)="onClick($event)">
        {{ section.section.header.text }}
        <i class="far fa-chevron-down"></i>
      </button>
      <div class="accordion-content">
        <app-content-repeater [items]="section.contents"></app-content-repeater>
      </div>
    </div>
  </ng-container>
</div>
